import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";

import "react-phone-input-2/lib/style.css";
import Phone from "./../utils/Phone";
import Direccion from "./../utils/Direccion";
import { parseJwt } from "./../utils/utils";

const { Select2, Date, DateTime, Text } = Inputs;

function Confirmacion({ history, match }) {
  const dispatch = useDispatch();
  const modelRegistro = useSelector((state) => state.registro);
  const [invitacionCodigo, setInvitacionCodigo] = useState(null);

  useEffect(() => {

   

    const data = modelRegistro?.data?.data;
    const error = modelRegistro?.error?.response?.data?.mensaje;

   

    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      alert("Confirmación exitosa, ahora podés ingresar");
      history.push("/login");
      dispatch(controller.duck.actions.clear());
    }
  }, [modelRegistro]);

  useEffect(() => {
    // componentDidMount
    if (match.params.token) {
      dispatch(controller.getInvitacionBytokenthunk(match.params.token));
    }
  }, []);

  const registrar = () => {

   

    if (!invitacionCodigo) {
      return alert("Por favor, escribí el código que te enviamos (también podés usar el enlace que te enviamos)");
    }

    let data = {
      invitacionId: match?.params?.invitacionId,
      invitacionCodigo,
    };

    dispatch(controller.registroThunk(data));
  };

  return (
    <Content title="Confirmación" browserTitle="Confirmación" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box>
            <Row style={{ marginBottom: 20 }}>
              <Col md="4" mdOffset="4">
              Te enviamos un mensaje para confirmar tu registro.
              Podés ingresar al enlace, o escribir aquí el código que te enviamos.
              </Col>
            </Row>

            <Text
              labelPosition="above"
              size="sm"
              label="Código"
              onChange={(evt) => setInvitacionCodigo(evt.target.value)}
            />

            <Button
              type="primary"
              text="Continuar"
              pullRight={true}
              onClick={() => registrar()}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default Confirmacion;
